module.exports = __webpack_public_path__ + "fb34c09ee9d799c346bb1b67f50d00f7.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular.eot
// module id = 380
// module chunks = 0